import { apiSlice } from '../apiSlice';

export const edutemAPI = apiSlice
  .enhanceEndpoints({ addTagTypes: ['edutem'] })
  .injectEndpoints({
    endpoints: (build) => ({
      getProofreading: build.query({
        query: (data: any) => ({
          url: `/edutem/v1/proofread`,
          method: 'POST',
          data,
        }),
        providesTags: ['edutem'],
      }),
      getReviewedContent: build.query({
        query: (reviewedId: number) => ({
          url: `/mgmt/tutor/learning-evaluation/reviewed/${reviewedId}`,
          method: 'GET',
        }),
        providesTags: ['edutem'],
      }),
      getCorrectionResultCount: build.query({
        query: (data: any) => ({
          url: `/mgmt/tutor/learning-evaluation/correction-results`,
          method: 'GET',
          params: data,
        }),
        providesTags: ['edutem'],
      }),
    }),
  });

export const {
  useLazyGetProofreadingQuery,
  useGetReviewedContentQuery,
  useGetCorrectionResultCountQuery,
}: any = edutemAPI;
